import { render, staticRenderFns } from "./RollRecentElement.vue?vue&type=template&id=7d4bf016&scoped=true"
import script from "./RollRecentElement.vue?vue&type=script&lang=js"
export * from "./RollRecentElement.vue?vue&type=script&lang=js"
import style0 from "./RollRecentElement.vue?vue&type=style&index=0&id=7d4bf016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4bf016",
  null
  
)

export default component.exports